import React, { Suspense, useState } from 'react';
import { useEffect } from 'react';
import { ScrollRestoration, useParams } from 'react-router-dom';
import { LMBackToTop } from '@/utils/display';
import Header from '@/components/layout/Header';
import Loading from '@/components/shared/Loading';
import Footer from '@/components/layout/Footer';
import Listing from '@/components/shared/Listing';

const ListingPage: React.FC = () => {
    const { listingID } = useParams();
    
    const [ mainElementClasses, setMainElementClasses ] = useState<string>( '' );
    const layoutClasses = ( classes: Array<string> ) => {
        setMainElementClasses( classes.join( ' ' ) );
    }
    
    useEffect( () => {
        new LMBackToTop();
    }, [] );  
    
    if ( listingID ) {
                               

        return (
            <>
            <Header />
            <main id="content" className={ mainElementClasses }>
                <Suspense fallback={ <Loading /> }>
                    <div className="container">
                        <Listing listingID={ listingID } />
                    </div>
                    <ScrollRestoration />
                </Suspense>
            </main>
            <Footer />
            </>
        );
    } else {
        return null;
    }
}
export default ListingPage;

